module.exports = new __parcel__URL__("logo-harry-potter.777d78c3.png").toString();